"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@aperza/util");
var AcTableItem = /** @class */ (function () {
    function AcTableItem() {
        this._index = 0;
        this._functionContext = undefined;
        /**
         * Selected by checkbox
         */
        this._selected = false;
    }
    AcTableItem.fromData = function (data, functionContext) {
        return data && util_1.ArrayUtil.isNotEmpty(data)
            ? data.map(function (entry, index) {
                var d = new AcTableItem();
                d.index = index;
                d.data = entry;
                d.functionContext = functionContext;
                return d;
            })
            : [];
    };
    Object.defineProperty(AcTableItem.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (value) {
            this._index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableItem.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableItem.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (value) {
            this._selected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AcTableItem.prototype, "functionContext", {
        get: function () {
            return this._functionContext;
        },
        set: function (value) {
            this._functionContext = value;
        },
        enumerable: true,
        configurable: true
    });
    return AcTableItem;
}());
exports.AcTableItem = AcTableItem;
//# sourceMappingURL=AcTableItem.js.map